import { render, staticRenderFns } from "./PatientIndex.vue?vue&type=template&id=6f9ec538&scoped=true"
import script from "./PatientIndex.vue?vue&type=script&lang=js"
export * from "./PatientIndex.vue?vue&type=script&lang=js"
import style0 from "./PatientIndex.vue?vue&type=style&index=0&id=6f9ec538&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ec538",
  null
  
)

export default component.exports